"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactDom = require("react-dom");
var _childrenWrapper = _interopRequireDefault(require("./mask/children-wrapper"));
var _hooks = require("./mask/hooks");
var _defer = require("./mask/utils/defer");
var _helpers = require("./mask/utils/helpers");
var _input = require("./mask/utils/input");
var _mask = _interopRequireDefault(require("./mask/utils/mask"));
var _validateProps = require("./mask/validate-props");
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var InputMask = function InputMask(WrappedComponent) {
  return (0, _react.forwardRef)(function (props, forwardedRef) {
    var alwaysShowMask = props.alwaysShowMask,
      children = props.children,
      mask = props.mask,
      maskPlaceholder = props.maskPlaceholder,
      beforeMaskedStateChange = props.beforeMaskedStateChange,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["alwaysShowMask", "children", "mask", "maskPlaceholder", "beforeMaskedStateChange"]);
    (0, _validateProps.validateMaxLength)(props);
    (0, _validateProps.validateMaskPlaceholder)(props);
    var maskUtils = new _mask["default"]({
      mask: mask,
      maskPlaceholder: maskPlaceholder
    });
    var isMasked = !!mask;
    var isEditable = !restProps.disabled && !restProps.readOnly;
    var isControlled = props.value !== null && props.value !== undefined;
    var previousIsMasked = (0, _hooks.usePrevious)(isMasked);
    var initialValue = (0, _helpers.toString)((isControlled ? props.value : props.defaultValue) || '');
    var _useInputState = (0, _hooks.useInputState)(initialValue, isMasked),
      inputRef = _useInputState.inputRef,
      getInputState = _useInputState.getInputState,
      setInputState = _useInputState.setInputState,
      getLastInputState = _useInputState.getLastInputState;
    var getInputElement = (0, _hooks.useInputElement)(inputRef);
    function onChange(event) {
      var currentState = getInputState();
      var previousState = getLastInputState();
      var newInputState = maskUtils.processChange(currentState, previousState);
      if (beforeMaskedStateChange) {
        newInputState = beforeMaskedStateChange({
          currentState: currentState,
          previousState: previousState,
          nextState: newInputState
        });
      }
      setInputState(newInputState);
      if (props.onChange) {
        props.onChange(event);
      }
    }
    function onFocus(event) {
      inputRef.current = event.target;
      var currentValue = getInputState().value;
      if (isMasked && !maskUtils.isValueFilled(currentValue)) {
        var newValue = maskUtils.formatValue(currentValue);
        var newSelection = maskUtils.getDefaultSelectionForValue(newValue);
        var newInputState = {
          value: newValue,
          selection: newSelection
        };
        if (beforeMaskedStateChange) {
          newInputState = beforeMaskedStateChange({
            currentState: getInputState(),
            nextState: newInputState
          });
          newValue = newInputState.value;
          newSelection = newInputState.selection;
        }
        setInputState(newInputState);
        if (newValue !== currentValue && props.onChange) {
          props.onChange(event);
        }
        (0, _defer.defer)(function () {
          setInputState(getLastInputState());
        });
      }
      if (props.onFocus) {
        props.onFocus(event);
      }
    }
    function onBlur(event) {
      var currentValue = getInputState().value;
      var lastValue = getLastInputState().value;
      if (isMasked && !alwaysShowMask && maskUtils.isValueEmpty(lastValue)) {
        var newValue = '';
        var newInputState = {
          value: newValue,
          selection: {
            start: null,
            end: null
          }
        };
        if (beforeMaskedStateChange) {
          newInputState = beforeMaskedStateChange({
            currentState: getInputState(),
            nextState: newInputState
          });
          newValue = newInputState.value;
        }
        setInputState(newInputState);
        if (newValue !== currentValue && props.onChange) {
          props.onChange(event);
        }
      }
      if (props.onBlur) {
        props.onBlur(event);
      }
    }
    function onMouseDown(event) {
      var input = getInputElement();
      var _getInputState = getInputState(),
        value = _getInputState.value;
      if (!(0, _input.isInputFocused)(input) && !maskUtils.isValueFilled(value)) {
        var mouseDownX = event.clientX;
        var mouseDownY = event.clientY;
        var mouseDownTime = new Date().getTime();
        var mouseUpHandler = function mouseUpHandler(mouseUpEvent) {
          document.removeEventListener('mouseup', mouseUpHandler);
          if (!(0, _input.isInputFocused)(input)) {
            return;
          }
          var deltaX = Math.abs(mouseUpEvent.clientX - mouseDownX);
          var deltaY = Math.abs(mouseUpEvent.clientY - mouseDownY);
          var axisDelta = Math.max(deltaX, deltaY);
          var timeDelta = new Date().getTime() - mouseDownTime;
          if (axisDelta <= 10 && timeDelta <= 200 || axisDelta <= 5 && timeDelta <= 300) {
            var _lastState = getLastInputState();
            var newSelection = maskUtils.getDefaultSelectionForValue(_lastState.value);
            var newState = _objectSpread(_objectSpread({}, _lastState), {}, {
              selection: newSelection
            });
            setInputState(newState);
          }
        };
        document.addEventListener('mouseup', mouseUpHandler);
      }
      if (props.onMouseDown) {
        props.onMouseDown(event);
      }
    }
    if (isMasked && isControlled) {
      var input = getInputElement();
      var isFocused = input && (0, _input.isInputFocused)(input);
      var newValue = isFocused || alwaysShowMask || props.value ? maskUtils.formatValue(props.value) : props.value;
      if (beforeMaskedStateChange) {
        newValue = beforeMaskedStateChange({
          nextState: {
            value: newValue,
            selection: {
              start: null,
              end: null
            }
          }
        }).value;
      }
      setInputState(_objectSpread(_objectSpread({}, getLastInputState()), {}, {
        value: newValue
      }));
    }
    var lastState = getLastInputState();
    var lastSelection = lastState.selection;
    var lastValue = lastState.value;
    (0, _react.useLayoutEffect)(function () {
      if (!isMasked) {
        return;
      }
      var input = getInputElement();
      var isFocused = (0, _input.isInputFocused)(input);
      var previousSelection = lastSelection;
      var currentState = getInputState();
      var newInputState = _objectSpread({}, currentState);
      if (!isControlled) {
        var currentValue = currentState.value;
        var formattedValue = maskUtils.formatValue(currentValue);
        var isValueEmpty = maskUtils.isValueEmpty(formattedValue);
        var shouldFormatValue = !isValueEmpty || isFocused || alwaysShowMask;
        if (shouldFormatValue) {
          newInputState.value = formattedValue;
        } else if (isValueEmpty && !isFocused) {
          newInputState.value = '';
        }
      }
      if (isFocused && !previousIsMasked) {
        newInputState.selection = maskUtils.getDefaultSelectionForValue(newInputState.value);
      } else if (isControlled && isFocused && previousSelection) {
        if (previousSelection.start !== null && previousSelection.end !== null) {
          newInputState.selection = previousSelection;
        }
      }
      if (beforeMaskedStateChange) {
        newInputState = beforeMaskedStateChange({
          currentState: currentState,
          nextState: newInputState
        });
      }
      setInputState(newInputState);
    });
    var inputProps = _objectSpread(_objectSpread({}, restProps), {}, {
      onFocus: onFocus,
      onBlur: onBlur,
      onChange: isMasked && isEditable ? onChange : props.onChange,
      onMouseDown: isMasked && isEditable ? onMouseDown : props.onMouseDown,
      ref: function ref(_ref) {
        inputRef.current = (0, _reactDom.findDOMNode)(_ref);
        if ((0, _helpers.isFunction)(forwardedRef)) {
          forwardedRef(_ref);
        } else if (forwardedRef !== null && (0, _typeof2["default"])(forwardedRef) === 'object') {
          forwardedRef.current = _ref;
        }
      },
      value: isMasked && isControlled ? lastValue : props.value
    });
    if (children) {
      (0, _validateProps.validateChildren)(props, children);
      return _react["default"].createElement(_childrenWrapper["default"], inputProps, children);
    }
    return _react["default"].createElement(WrappedComponent, inputProps);
  });
};
InputMask.displayName = 'InputMask';
InputMask.defaultProps = {
  alwaysShowMask: false,
  maskPlaceholder: '_'
};
InputMask.propTypes = {
  alwaysShowMask: _propTypes["default"].bool,
  beforeMaskedStateChange: _propTypes["default"].func,
  children: _propTypes["default"].element,
  mask: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].instanceOf(RegExp)]))]),
  maskPlaceholder: _propTypes["default"].string,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  onMouseDown: _propTypes["default"].func
};
var _default = InputMask;
exports["default"] = _default;